import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative z-10" }
const _hoisted_2 = {
  key: 0,
  class: "absolute w-44 min-h-64 h-auto bg-custom-primaryBlack bottom-0 right-0 rounded-br-3xl px-2 py-2 border border-white"
}

import { useMapStore } from "@/store/useMapStore";
import { computed, ref } from "vue";
import PaletteIcon from "@/components/Icons/PaletteIcon.vue";
import TextSmall from "@/components/Texts/TextSmall.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaletteMenu',
  setup(__props) {

const mapStore = useMapStore();
const legendColors = computed(() => {
  return mapStore.legendsColor;
});
const isOpen = ref(false);
const toggleLegend = () => {
  isOpen.value = !isOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PaletteIcon, { onClick: toggleLegend })
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legendColors.value, (legendColor) => {
            return (_openBlock(), _createElementBlock("div", {
              key: legendColor.name,
              class: "flex flex-row space-x-2 space-y-2 items-center"
            }, [
              _createElementVNode("div", {
                class: "w-6 h-6 bg-red-500 border border-custom-lightGray",
                style: _normalizeStyle('background-color: ' + legendColor.color)
              }, null, 4),
              _createVNode(TextSmall, {
                text: legendColor.name
              }, null, 8, ["text"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})